import { Box, Button, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import './Banner.css';
import logo from '../../images/dark.png';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import profilePic from '../../images/va.jpg';
import profileAni from '../../images/47-60.jpg';
import { MyButton } from '../../Styles/Styles';
//Animation elements
import 'animate.css';
import ele1 from '../../images/1.svg';
import ele2 from '../../images/2.svg';
import ele3 from '../../images/3.svg';
import ele4 from '../../images/4.svg';
import ele5 from '../../images/5.svg';
import ele6 from '../../images/dot.svg';
import ele7 from '../../images/dot-2.svg';
import ele8 from '../../images/8.svg';
import ele9 from '../../images/9.svg';

const Banner = () => {
    return (
        <Box style={{ position: 'relative' }}>
            <Box className='hero'></Box>
            <Container maxWidth='xl' sx={{ position: 'relative' }} style={{ zIndex: 9999 }}>
                {/* MENU */}
                <Box sx={[{ display: { xs: 'block', sm: 'flex' }, justifyContent: 'space-between', alignItems: 'center', textAlign: 'center', py: 2, zIndex: 9999, position: { xs: 'absolute' }, width: '100%', }]}>
                    <Box>
                        {/* LOGO */}
                        <img style={{ width: '150px' }} src={logo} alt="" />
                    </Box>
                    <Box sx={[{ display: { xs: 'block', sm: 'flex' }, alignItems: 'center', justifyContent: 'center', gap: 2 }]}>
                        {/* Call to Action */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <a href=""><FacebookIcon style={{ color: '#3B5999' }} /></a>
                            <a href=""><TwitterIcon style={{ color: '#03A9F4' }} /></a>
                            <a href=""><InstagramIcon style={{ color: '#F34337' }} /></a>
                            <a href=""><YouTubeIcon style={{ color: '#FF0000' }} /></a>
                        </Box>
                        <Box>
                            <MyButton variant='contained' sx={[{ fontSize: { xs: '12px', sm: '20px' }, mr: { xs: 0, sm: 5 } }]} size='large'>Download CV</MyButton>
                        </Box>
                    </Box>
                </Box>

                {/* HERO */}

                <Box sx={[{ pt: { xs: 25, sm: 18, md: 20, lg: 25 } }]}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={12} md={6}>
                            <Typography variant='h4' sx={[{ fontSize: { xs: '20px', sm: '25px', md: '30px' } }]} fontWeight={700} color='primary.main'>I'm</Typography>
                            <Typography variant='h1' sx={[{ fontSize: { xs: '30px', md: '80px', lg: '120px' }, lineHeight: { xs: '30px', md: '80px', lg: '120px' } }]} fontWeight={700}>Sakib Ahmed <br /> Saron </Typography>
                            <Typography variant='h5' sx={[{ fontSize: { xs: '16px', sm: '20px', md: '24px' }, mt: { xs: 2 } }]} color='muted.main'>A passionate UI/UX Designer and Web Developer based In NYC, USA</Typography>

                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Box sx={[{ position: 'absolute', right: { xs: '20%', sm: '30%', md: '10%' } }]}>
                                <Box className='overlay'></Box>
                                <img src={profilePic} className='profileImg' alt="" />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>


            </Container>



            {/* ANIMATION ELEMENTS OF BANNER */}
            <Box sx={{ position: 'absolute', width: '100%', top: 0, zIndex: 0 }}>
                <Box sx={{ height: '100vh', position: 'relative' }}>
                    <Box sx={{ position: 'absolute', top: '10%', left: '3%', zIndex: 0 }}>
                        <img src={ele9} style={{ width: '30px' }} className='scale _circle' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '20%', left: '8%', zIndex: 0 }}>
                        <img src={ele1} style={{ width: '30px' }} className='fullSpin _square' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '35%', left: '5%', zIndex: 0 }}>
                        <img src={ele5} style={{ width: '40px' }} className='fullSpin _stick' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '75%', left: '3%', zIndex: 0 }}>
                        <img src={ele3} style={{ width: '30px' }} className='fullSpin _piramid' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '70%', left: '8%', zIndex: 0 }}>
                        <img src={ele4} style={{ width: '30px' }} className='leftRight _3m' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '50%', left: '3%', zIndex: 0 }}>
                        <img src={ele6} style={{ width: '80px' }} className='leftRight _dots1' alt="" />
                    </Box>

                    <Box sx={{ position: 'absolute', top: '80%', left: '50%', zIndex: 0 }}>
                        <img src={ele2} style={{ width: '30px' }} className='halfSpin _A' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '20%', left: '30%', zIndex: 0 }}>
                        <img src={ele3} style={{ width: '30px' }} className='fullSpin _piramid' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '70%', left: '40%', zIndex: 0 }}>
                        <img src={ele9} style={{ width: '30px' }} className='scale _circle' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '56%', left: '30%', zIndex: 0 }}>
                        <img src={ele5} style={{ width: '30px' }} className='fullSpin _stick' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '40%', left: '50%', zIndex: 0 }}>
                        <img src={ele4} style={{ width: '40px' }} className='leftRight _3m' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '15%', left: '60%', zIndex: 0 }}>
                        <img src={ele9} style={{ width: '20px' }} className='scale _circle' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '14%', left: '59.8%', zIndex: 0 }}>
                        <img src={ele1} style={{ width: '30px' }} className='fullSpin _square' alt="" />
                    </Box>

                    <Box sx={{ position: 'absolute', top: '5%', right: '5%', zIndex: 0 }}>
                        <img src={ele7} style={{ width: '80px' }} className='upDown _dots2' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '40%', right: '5%', zIndex: 0 }}>
                        <img src={ele8} style={{ width: '40px' }} className='fullSpin _stick' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '70%', right: '5%', zIndex: 0 }}>
                        <img src={ele9} style={{ width: '30px' }} className='scale _circle' alt="" />
                    </Box>
                    <Box sx={{ position: 'absolute', top: '80%', right: '8%', zIndex: 0 }}>
                        <img src={ele1} style={{ width: '30px' }} className='fullSpin _square' alt="" />
                    </Box>
                </Box>
            </Box>
            {/* ANIMATION ELEMENTS OF BANNER */}



        </Box>
    );
};

export default Banner;